import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';

const ICON = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0 }}>
    <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
    <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
    <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
    <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
  </svg>
);

function GoogleLoginBtn({ onSuccess, onError, label }) {
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const login = useGoogleLogin({
    onSuccess: async (res) => {
      setErr('');
      setBusy(true);
      try {
        const r = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${res.access_token}` },
        });
        const profile = await r.json();
        onSuccess?.({
          token: res.access_token,
          email: profile.email,
          first_name: profile.given_name || '',
          last_name: profile.family_name || '',
        });
      } catch {
        setErr('Google sign-in failed. Try again.');
        onError?.();
      } finally {
        setBusy(false);
      }
    },
    onError: () => {
      setErr('Google sign-in unavailable. Use email below.');
      onError?.();
    },
  });

  return (
    <div>
      <button type="button" className="social-btn" onClick={() => { setErr(''); login(); }} disabled={busy}>
        {ICON}
        {busy ? 'Signing in…' : label}
      </button>
      {err && <div style={{ fontSize: 12, color: 'var(--fg-dim)', marginTop: 6, textAlign: 'center' }}>{err}</div>}
    </div>
  );
}

export default function GoogleButton({ label = 'Continue with Google', onSuccess, onError }) {
  return <GoogleLoginBtn label={label} onSuccess={onSuccess} onError={onError} />;
}
